import { createContext } from "react";

const Mp3ControllerContext = createContext(null);

export default Mp3ControllerContext;
